import { render } from "./TemplateDetail.vue?vue&type=template&id=fb7338a4&scoped=true"
import script from "./TemplateDetail.vue?vue&type=script&lang=js"
export * from "./TemplateDetail.vue?vue&type=script&lang=js"

import "./TemplateDetail.vue?vue&type=style&index=0&id=fb7338a4&lang=css"
import "./TemplateDetail.vue?vue&type=style&index=1&id=fb7338a4&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb7338a4"]])

export default __exports__